import React from 'react'
import StyledH5Heading from '../../../common/components/styledH5Heading/StyledH5Heading'
import JoinNetworkCard from '../../../components/joinNetworkCard/JoinNetworkCard'

const joinNetworkData = [
    {
        tagline: "CONNECT",
        heading: "Connect chains",
        desc: "Grow the economy of your chain by connecting to HopeLedger Hub services using IBC protocol.",
        icon: "/assets/images/square-1.svg"
    },
    {
        tagline: "INTEGRATE",
        heading: "Provide services",
        desc: "Get support to bring users to HopeLedger by providing services such as exchanges, wallets and more.",
        icon: "/assets/images/square-2.svg"
    },
    {
        tagline: "VALIDATE",
        heading: "Validator level",
        desc: "Join the ranks of trusted decentralized validator operators in the network and help secure the interchain.",
        icon: "/assets/images/square-3.svg"
    },
]

const JoinNetworkSection = () => {
    return (
        <div className='w-[90%] flex flex-col gap-10 lg:gap-20 py-20'>
            <div className='text-center'>
                <StyledH5Heading fontColor="text-gradient">Join the network.</StyledH5Heading>
            </div>
            <div className='flex flex-col gap-5 lg:flex-row'>
                {
                    joinNetworkData?.map((item, index) => (
                        <div className='lg:w-[33.3%]' key={index}>
                            <JoinNetworkCard index={index} data={item} />
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default JoinNetworkSection
